import type { EventIncidentType, EventType } from "../types/eventType";
export default class IncidentsHelper {
  static updateEventIncidentData(
    event: EventType,
    eventIncidentUpdate: EventIncidentType
  ) {
    // some events dont have event incidents when fetched initially
    if (event["eventIncidents"] === undefined) {
      return;
    }

    let eventIncident = event["eventIncidents"][0];
    eventIncident["dangerballStatus"] = eventIncidentUpdate["dangerballStatus"];
    eventIncident["scoreDetails"] = eventIncidentUpdate["scoreDetails"];
    eventIncident["currentPeriodScoreDetails"] =
      eventIncidentUpdate["currentPeriodScoreDetails"];
    eventIncident["eventPhase"] = eventIncidentUpdate["eventPhase"];
    eventIncident["phaseStartDate"] = eventIncidentUpdate["phaseStartDate"];

    if (eventIncidentUpdate["teamName"] !== undefined) {
      eventIncident["teamName"] = eventIncidentUpdate["teamName"];
    }

    // BET-2298 if type present update event incident type
    if (eventIncidentUpdate.type !== undefined) {
      eventIncident.type = eventIncidentUpdate.type;
    } else {
      eventIncident.type = "";
    }
  }
}
